<template lang="pug">
  section.section.features
    .section-separator
      h3 {{ $t("features.title") }}

      .features__list
        .features__item(
          v-for="(video_id, type) in features",
          :key="`feature-${type}`"
        )
          .features__item__image
            img(:src="getImagePath(type)")
            span.video-button(@click="showVideo('vk', video_id)")

          .features__item__title {{ $t(`features.${type}.title`) }}
          p {{ $t(`features.${type}.description`) }}
</template>

<script>
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixinNew";
export default {
  name: "Features",

  mixins: [MobileDetection],

  data() {
    return {
      video: null,
      features: {
        openworld: "-175278730_456239460",
        pvp: "-175278730_456241481",
        pve: "-175278730_456239649",
        peaceful: "-175278730_456239573",
      },
    };
  },

  methods: {
    getImagePath(id) {
      return require(`@/assets/images/features/feature-${id}.jpg`);
    },

    showVideo(video_type="youtube", video_id) {
      if (this.isTabletWideMax) {
        if(video_type === "vk") {
          let video_id_part = video_id.split("_");
          window.open(
            `https://vk.com/video_ext.php?oid=${video_id_part[0]}&id=${video_id_part[1]}&hd=2&autoplay=1"`
          );
        } else {
          window.open(
            `https://www.youtube.com/embed/${video_id}?autoplay=1&rel=0&showinfo=0`, "_blank"
          );
        }
      } else {
        this.$emit("showVideo", video_type, video_id);
      }
    },
  },
};
</script>
